import update from 'immutability-helper';

export const perfiles = (state = {
    "options"  : false,
    "selected" : false
}, action) => {
    switch (action.type) {
		case "MERGE-PERFILES-STATES":
			state = update(state, {$merge: action.payload});
		break;

        default:
            return state;
    }

    return state
};